import script from './component-lib.esm2.js';
import normalizeComponent from '../../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "v-stacked-layout",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('div', {
    staticClass: "v-stacked-layout__btns",
    style: _vm.btnStyles
  }, [_c('ProfileBtn', _vm._b({
    ref: "btn",
    staticClass: "v-stacked-layout__btn",
    attrs: {
      "component": "button",
      "label": _vm.link.label,
      "variant": _vm.btnVariant,
      "aria-expanded": _vm.isOpen.toString(),
      "aria-controls": _vm.contentId
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'ProfileBtn', _vm.btnProps, false), [_c('ChevronIcon', {
    staticClass: "v-stacked-layout__btn__icon",
    attrs: {
      "slot": "icon-right"
    },
    slot: "icon-right"
  })], 1), _vm._v(" "), _vm._l(2, function (i) {
    return _c('ProfileBtn', _vm._b({
      key: i,
      staticClass: "v-stacked-layout__btn",
      attrs: {
        "component": "button",
        "aria-hidden": "true",
        "tabindex": "-1",
        "variant": _vm.btnVariant
      }
    }, 'ProfileBtn', _vm.btnProps, false), [_vm._v("\n       \n    ")]);
  })], 2), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "v-stacked-layout__content",
    attrs: {
      "id": _vm.contentId,
      "aria-hidden": (!_vm.isOpen).toString()
    }
  }, [_vm.isOpen ? [_c('div', {
    staticClass: "v-stacked-layout__lines-bg",
    style: _vm.linesStyles
  }), _vm._v(" "), _vm.isLoading ? _vm._l(_vm.options.number_of_enabled_links, function (i) {
    return _c('ProfileLinkWrapper', {
      key: i
    }, [_c('ProfileBtnSkeleton', {
      attrs: {
        "color": _vm.btnBgColor,
        "size": _vm.btnProps.size
      }
    })], 1);
  }) : _vm._t("default", null, {
    "attrs": {
      tabindex: _vm.isOpen ? '0' : '-1'
    }
  })] : _vm._e()], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-05bef516_0", {
    source: ".v-stacked-layout[data-v-05bef516]{--c-container-transition-speed:500ms;transition:height var(--c-container-transition-speed)}.v-stacked-layout__btns[data-v-05bef516]{position:relative}.v-stacked-layout__btn[data-v-05bef516]{left:0;top:0;z-index:3}.v-stacked-layout__btn[data-v-05bef516]:not(:first-child){position:absolute;top:0;width:100%;pointer-events:none;height:var(--c-btn-height)}.v-stacked-layout__btn[data-v-05bef516]:nth-child(2){transform:translate(4px,8px);z-index:2}.v-stacked-layout__btn[data-v-05bef516]:nth-child(3){transform:translate(8px,16px);z-index:1}.v-stacked-layout--closed[data-v-05bef516]{padding-bottom:1rem}.v-stacked-layout--closed .v-stacked-layout__btn[data-v-05bef516]{box-shadow:0 2px 3px 1px var(--c-box-shadow-color)}.v-stacked-layout--closed .v-stacked-layout__btn[data-v-05bef516]:first-child{transform:none}.v-stacked-layout--open[data-v-05bef516]{padding-bottom:var(--p-btn-box-shadow-size)}.v-stacked-layout--open .v-stacked-layout__btns[data-v-05bef516]{margin-bottom:var(--p-btn-margin-bottom);padding-bottom:var(--p-btn-box-shadow-size)}.v-stacked-layout--open .v-stacked-layout__btn[data-v-05bef516]:not(:first-child){opacity:0;visibility:hidden}.v-stacked-layout--open .v-stacked-layout__btn__icon[data-v-05bef516]{transform:rotate(180deg)}.v-stacked-layout--closed:focus-within .v-stacked-layout__btn[data-v-05bef516]:nth-child(2),.v-stacked-layout--closed:hover .v-stacked-layout__btn[data-v-05bef516]:nth-child(2){transform:translate(4px,10px)}.v-stacked-layout--closed:focus-within .v-stacked-layout__btn[data-v-05bef516]:nth-child(3),.v-stacked-layout--closed:hover .v-stacked-layout__btn[data-v-05bef516]:nth-child(3){transform:translate(8px,20px)}.v-stacked-layout__lines-bg[data-v-05bef516]{position:absolute}.v-stacked-layout__lines-bg[data-v-05bef516]:before{--top-spacing:calc(\n    (var(--p-btn-margin-bottom) + var(--p-btn-box-shadow-size))\n  );background:linear-gradient(to bottom,transparent,var(--c-connector-color) var(--p-btn-margin-bottom));height:calc(100% - var(--c-last-link-height)/ 2 - var(--p-btn-box-shadow-size)/ 2 + var(--top-spacing) + .075rem);left:-.5rem;content:\"\";position:absolute;top:calc(var(--top-spacing) * -1);width:.15rem}.v-stacked-layout__content[data-v-05bef516]{padding-left:1rem}.v-stacked-layout__content[data-v-05bef516] .link-wrapper:before{position:absolute;content:\"\";width:.35rem;height:.15rem;background:linear-gradient(to right,var(--c-connector-color),transparent);top:50%;transform:translateY(-50%);left:-.35rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-05bef516";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var StackedLayout = __vue_component__;
export { StackedLayout as default };